const Privacy = () => {
  console.log("🔧 Privacy component is rendering...");
  console.log("🔧 Current URL:", window.location.pathname);

  return (
    <section className="min-h-screen bg-background text-foreground">
      <div className="container mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

        <div className="rounded-lg border border-border bg-card/50 p-6">
          <p className="text-lg text-muted-foreground">
            We collect only the information needed to provide our services (like your
            email for the waitlist). We don&apos;t sell personal data.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
